import { createSelector } from "@ngrx/store";
import { PotentialCauseState } from "../reducers/potential-cause.reducer";
import { PotentialConsequenceState } from "../reducers/potential-consequence.reducer";

export const selectPotentialConsequenceState = (state: any) => state.potentialConsequence;

export const selectPotentialConsequences = createSelector(
    selectPotentialConsequenceState,
  (state: PotentialConsequenceState) => state.potentialConsequences
);

export const selectPotentialConsequencesLoading = createSelector(
  selectPotentialConsequenceState,
  (state: PotentialConsequenceState) =>{
    return  state.loading
  }
);
export const selectPotentialConsequencesError = createSelector(
  selectPotentialConsequenceState,
  (state: PotentialConsequenceState) => state.error
);